export default __webpack_public_path__ + "static/media/ga-login2.993cf563.svg";